import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ✅ Phase 2A.2 — Theme v2 (Bapatla Attendance brand alignment)
// Loaded BEFORE component CSS so its tokens are available everywhere.
import './styles/theme.css';
import './styles/GlobalTheme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
